import { getSnapshot, types } from 'mobx-state-tree'

export type TTransportToPortMode = 'truck' | 'intermodal' | 'barge'

export interface IMQAdditionalRequirements {
  isHeavyTestedContainer: boolean
  letterOfCreditRequired: boolean
  maxPayloadContainer: string
  maxDemurrageTime: string
  EXWDate: string
  transportToPortMode: TTransportToPortMode
  transportCompanyPreference: string
}

export const ManualQuoteAdditionalFieldsModel = types
  .model('ManualQuoteAdditionalFieldsModel', {
    isHeavyTestedContainer: types.optional(types.boolean, false),
    letterOfCreditRequired: types.optional(types.boolean, false),
    maxPayloadContainer: types.optional(types.string, ''),
    maxDemurrageTime: types.optional(types.string, ''),
    EXWDate: types.optional(types.string, ''),
    transportToPortMode: types.maybe(
      types.union(types.literal('truck'), types.literal('intermodal'), types.literal('barge'))
    ),
    transportCompanyPreference: types.optional(types.string, ''),
  })
  .views((self) => ({
    get JSON(): IMQAdditionalRequirements {
      return getSnapshot(self)
    },
  }))
  .actions((self) => ({
    setIsHeavyTestedContainer(isHeavyTestedContainer: boolean): void {
      self.isHeavyTestedContainer = isHeavyTestedContainer
    },
    setLetterOfCreditRequired(letterOfCreditRequired: boolean): void {
      self.letterOfCreditRequired = letterOfCreditRequired
    },
    setMaxPayloadContainer(maxPayloadContainer: string): void {
      self.maxPayloadContainer = maxPayloadContainer
    },
    setMaxDemurrageTime(maxDemurrageTime: string): void {
      self.maxDemurrageTime = maxDemurrageTime
    },
    setEXWDate(EXWDate: string): void {
      self.EXWDate = EXWDate
    },
    setTransportToPortMode(transportToPortMode: TTransportToPortMode): void {
      self.transportToPortMode = transportToPortMode
    },
    setTransportCompanyPreference(transportCompanyPreference: string): void {
      self.transportCompanyPreference = transportCompanyPreference
    },
  }))

export type TManualQuoteAdditionalFieldsModel = typeof ManualQuoteAdditionalFieldsModel.Type
